// extracted by mini-css-extract-plugin
export default {"tooltip":"on-z","sharingV2":"pn-z","sharingIconsV2":"qn-z","links":"rn-z","link":"sn-z","facebookV2":"tn-z","twitterV2":"un-z","pinterestV2":"vn-z"};